import { Trash2, Pencil, ShieldCheck, ShieldOff, UserCog } from "lucide-react";
import { Card, EmptyState, StatusBadge, formatDate } from "../../ui";
import { formatPhone } from "../../../lib/masks";
import { ROLE_LABEL } from "./shared";

export function UserList({ filtered, list, openEdit, remove, toggleStatus }) {
  return (
    <>
      {list === null ? (
        <div className="text-sm text-slate-500">Carregando...</div>
      ) : filtered.length === 0 ? (
        <EmptyState
          title="Nenhum usuário cadastrado"
          hint="Use o botão acima para criar Conselheiros e Diretores."
        />
      ) : (
        <Card>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[10px] uppercase tracking-wide text-slate-500">
                <tr>
                  <th className="text-left p-3">Nome</th>
                  <th className="text-left p-3">E-mail</th>
                  <th className="text-left p-3">Telefone</th>
                  <th className="text-left p-3">Função</th>
                  <th className="text-left p-3">Status</th>
                  <th className="text-left p-3">Criado em</th>
                  <th className="text-right p-3">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((u) => (
                  <tr
                    key={u.id}
                    data-testid={`iu-row-${u.id}`}
                    className="border-t border-slate-100 hover:bg-slate-50"
                  >
                    <td className="p-3 font-medium">{u.name}</td>
                    <td className="p-3 text-slate-600">{u.email}</td>
                    <td className="p-3 text-slate-600">
                      {u.phone ? (
                        formatPhone(u.phone)
                      ) : (
                        <span className="text-slate-400 text-xs">—</span>
                      )}
                    </td>
                    <td className="p-3">
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-[#002776]/30 bg-[#002776]/8 text-[#002776] text-[11px]">
                        <UserCog size={11} /> {ROLE_LABEL[u.role] || u.role}
                      </span>
                    </td>
                    <td className="p-3">
                      <StatusBadge status={u.status} />
                    </td>
                    <td className="p-3 text-slate-600">
                      {formatDate(u.created_at)}
                    </td>
                    <td className="p-3 text-right">
                      <div className="inline-flex gap-1">
                        <button
                          data-testid={`iu-edit-${u.id}`}
                          onClick={() => openEdit(u)}
                          title="Editar"
                          className="px-2 py-1 border border-slate-300 text-[10px] uppercase tracking-wide hover:border-[#002776]"
                        >
                          <Pencil size={12} />
                        </button>
                        <button
                          data-testid={`iu-toggle-${u.id}`}
                          onClick={() => toggleStatus(u)}
                          title={
                            u.status === "ativo" ? "Desativar" : "Reativar"
                          }
                          className={`inline-flex items-center gap-1 px-2 py-1 border text-[10px] uppercase tracking-wide ${
                            u.status === "ativo"
                              ? "border-rose-300 text-rose-700 hover:bg-rose-50"
                              : "border-emerald-300 text-emerald-700 hover:bg-emerald-50"
                          }`}
                        >
                          {u.status === "ativo" ? (
                            <>
                              <ShieldOff size={12} /> Desativar
                            </>
                          ) : (
                            <>
                              <ShieldCheck size={12} /> Reativar
                            </>
                          )}
                        </button>
                        <button
                          data-testid={`iu-delete-${u.id}`}
                          onClick={() => remove(u)}
                          title="Excluir"
                          className="px-2 py-1 border border-rose-300 text-rose-700 text-[10px] uppercase tracking-wide hover:bg-rose-50"
                        >
                          <Trash2 size={12} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}

    </>
  );
}
